import { faBath, faCartXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classes from 'components/Bookings2/Navbar/Navbar.module.scss';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { BookingsAbandonedPath, BookingsGroomingPath } from 'routes/Paths';

export const BookingsNavbar: React.FC = () => {
    return (
        <div className={classes.root}>
            <p className={classes.title}>Your Bookings</p>

            <nav className={classes.menu}>
                <NavLink
                    to={BookingsGroomingPath}
                    className={classes.menuLink}
                    isActive={(_, location) => {
                        return ![BookingsAbandonedPath].includes(location.pathname);
                    }}
                >
                    <FontAwesomeIcon icon={faBath} />
                    Grooming
                </NavLink>

                <NavLink
                    to={BookingsAbandonedPath}
                    className={classes.menuLink}
                >
                    <FontAwesomeIcon icon={faCartXmark} />
                    Abandoned
                </NavLink>
            </nav>
        </div>
    );
};
